import { SimNaoEnum } from 'components/form'
import { Calculation } from 'final-form-calculate'
import { metaPath } from 'util/metaPath'

import { ConsultaSeguimentoAplicacaoModel } from './model-consultaSeguimento'
import { ConsultaSeguimentoPergunta02Model } from './perguntas/consulta-seguimento-pergunta-02/model-consultaSeguimentoPergunta02'

const meta = metaPath<ConsultaSeguimentoAplicacaoModel>()

export const consultaSeguimentoCalculator: Calculation[] = [
  {
    field: meta.PERGUNTA_02.PERGUNTA_02_FEZ_EXAME.absolutePath(),
    updates: {
      [meta.PERGUNTA_02.PERGUNTA_02_RESULTADO_EXAME.absolutePath()]: (
        value: ConsultaSeguimentoPergunta02Model['PERGUNTA_02_FEZ_EXAME'],
        allValues: ConsultaSeguimentoAplicacaoModel
      ) => {
        if (value !== SimNaoEnum.SIM) {
          return null
        }
        return allValues.PERGUNTA_02.PERGUNTA_02_RESULTADO_EXAME
      },
    },
  },
]
